<template>
  <div class="tools mvxl">
    <div class="grid-container">
      <h2 class="header">
        {{ $t("tools.commonly-used-tools") }}
      </h2>
    </div>
    <div class="tools-grid">
      <div class="grid-x top-row">
        <div
          v-for="(image, index) in imagesTop"
          :key="index"
          class="cell auto tool-grid-item"
          @mouseover="setHover(index, true)"
          @mouseleave="setHover(index, false)"
        >
          <a
            class="image-container"
            :href="image.link"
          >
            <img
              :src="hover[index] ? image.normal : image.inverted"
              alt=""
            >
            <div
              class="title"
              :class="{
                'inverted-title': image.shouldInvertTitle && hover[index],
              }"
            >
              <span>{{ $t(image.titleKey) }}</span> <i
                aria-hidden="true"
                class="fas fa-angle-right fa-lg show-for-small-only"
              />
            </div>
          </a>
        </div>
      </div>
      <div class="grid-x bottom-row">
        <div
          v-for="(image, index) in imagesBottom"
          :key="index + imagesBottom.length"
          class="cell auto tool-grid-item"
          @mouseover="setHover(index + imagesBottom.length, true)"
          @mouseleave="setHover(index + imagesBottom.length, false)"
        >
          <a
            class="image-container"
            :href="image.link"
          >
            <img
              :src="
                hover[index + imagesBottom.length] ? image.normal : image.inverted
              "
              alt=""
            >
            <div
              class="title"
              :class="{
                'inverted-title': image.shouldInvertTitle && hover[index + imagesBottom.length],
              }"
            >
              <span>{{ $t(image.titleKey) }}</span> <i
                aria-hidden="true"
                class="fas fa-angle-right fa-lg show-for-small-only"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="grid-container group button-padding">
      <a
        class="button float-right content-type-featured"
        href="https://www.phila.gov/tools/"
        aria-label="See all tools "
      >
        {{ $t("tools.see-all-tools") }}
        <i
          class="fas fa-angle-right fa-lg"
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hover: {},
      imagesTop: [
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools1.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools1inverted.jpg",
          shouldInvertTitle: false,
          link: "https://www.phila.gov/parks-rec-finder/#/",
          titleKey: "tools.parks-finder",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools2.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools2inverted.jpg",
          shouldInvertTitle: true,
          link: "https://contracts.phila.gov/",
          titleKey: "tools.contracts",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/ost-finder.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/ost-finder-inverted.jpg",
          shouldInvertTitle: false,
          link: "https://www.phila.gov/ost/program-locator/#/",
          titleKey: "tools.school-time-activity",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools4.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools4inverted.jpg",
          shouldInvertTitle: true,
          link: "https://www.phila.gov/food/",
          titleKey: "tools.food-meal",
        },
      ],
      titlesTop: [
        "Parks and recreation finder",
        "Contracts hub",
        "Out-of-school time activity finder",
        "Free food and meal finder",
      ],
      imagesBottom: [
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools5.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools5inverted.jpg",
          shouldInvertTitle: true,
          link: "https://atlas.phila.gov/",
          titleKey: "tools.atlas",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools6.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools6inverted.jpg",
          shouldInvertTitle: false,
          link: "https://www.phila.gov/primary-care/",
          titleKey: "tools.primary",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools7.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools7inverted.jpg",
          shouldInvertTitle: false,
          link: "https://eclipse.phila.gov/",
          titleKey: "tools.eclipse",
        },
        {
          normal: "https://www.phila.gov/assets/images/website/tools/tools-tile-streetsmart.jpg",
          inverted: "https://www.phila.gov/assets/images/website/tools/tools8inverted.jpg",
          shouldInvertTitle: false,
          link: "https://streetsmartphl.phila.gov/",
          titleKey: "tools.street-smart",
        },
      ],
      titlesBottom: [ "Atlas", "Primary care finder", "Eclipse", "StreetSmartPHL" ],
    };
  },
  methods: {
    setHover(index, value) {
      this.$set(this.hover, index, value);
    },
  },
};
</script>